import { useState, useEffect } from 'react';
import axios from 'axios';

export function useFunctionCatalog() {
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get('/knowledge/functions')
      .then((res) => {
        const payload = res.data;
        const normalizedCatalog =
          payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};

        setCatalog(normalizedCatalog);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return { catalog, loading, error };
}
